import styled from "styled-components";
import Icon from "@material-ui/core/Icon";
import React from "react";
const StyledAddMoreButton = styled.button `
    height: ${(props) => (props.size == "large" ? "100px" : "50px")};
    border: 2px dashed ${(props) => props.theme.colors.primary.light.color}
    background-color: transparent;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #9E9E9E;
    cursor: pointer;
    margin-bottom: ${(props) => props.theme.MUITheme.spacing(4)};
    &:hover {
        background-color: ${(props) => props.theme.colors.primary.main.color}0d;
    }
    .material-icons {
        color: ${(props) => props.theme.colors.primary.main.color};
        margin-right: ${(props) => props.theme.MUITheme.spacing(2) + "px"}
    }
`;
const AddMoreButton = ({ onClick, text, size }) => {
    return (React.createElement(StyledAddMoreButton, { onClick: onClick, size: size },
        React.createElement(Icon, null, "add_circle"),
        text));
};
AddMoreButton.defaultProps = {
    size: "medium",
};
export default AddMoreButton;
